export const apiConfig = {
    baseUrl: 'https://ratestrip.abouthotelier.com/API/Price/GetPrice',
    baseStatsUrl: 'https://ratestrip.abouthotelier.com/API/Price/PluginStats',
    contactUsUrl: 'https://hotelmanager.abouthotelier.com/API/Price/ContactUs',
    getOfferUrl: 'https://ratestrip.abouthotelier.com/API/Price/GetOffer',
    click2Call: 'https://hotelmanager.abouthotelier.com/API/Price/ClickToCall',
    roomForm: 'https://ratestrip.abouthotelier.com/API/Price/roomForm',
    // roomForm: 'https://devhotelmanager.abouthotelier.com/API/Price/roomForm',
    addToCartBack:
        'https://ratestrip.abouthotelier.com/API/Price/addToCartBack',
    removeFromCartBack:
        'https://ratestrip.abouthotelier.com/API/Price/removeFromCartBack',
    updateToCartBack:
        'https://ratestrip.abouthotelier.com/API/Price/updateToCartBack',
    removeFromCartExtraBack:
        'https://ratestrip.abouthotelier.com/API/Price/removeFromCartExtraBack',
    addCartItemExtraBack:
        'https://ratestrip.abouthotelier.com/API/Price/addCartItemExtraBack',
    updateCartItemExtraBack:
        'https://ratestrip.abouthotelier.com/API/Price/updateCartItemExtraBack',
    getAddOns: 'https://ratestrip.abouthotelier.com/API/Price/getAddOns',
    getFinalPrices:
        'https://ratestrip.abouthotelier.com/API/Price/getFinalPrices',
    getCValidation:
        'https://ratestrip.abouthotelier.com/API/Price/getCValidation',
    checkAddOns: 'https://ratestrip.abouthotelier.com/API/Price/checkAddOns',
    getCart: 'https://ratestrip.abouthotelier.com/API/Price/getCart',
    // submitCartBack:
    //     'https://devhotelmanager.abouthotelier.com/API/Price/submitCartBack',
    submitCartBack:
        'https://ratestrip.abouthotelier.com/API/Price/submitCartBack',

    trackPrices: 'https://hotelmanager.abouthotelier.com/API/Price/TrackPrices',
    shareHotel: 'https://hotelmanager.abouthotelier.com/API/Price/ShareHotel',
    moreReviewsUrl:
        'https://ratestrip.abouthotelier.com/API/Price/GetPropertyCommentsMore',
    // 'https://devhotelmanager.abouthotelier.com/API/Price/GetPropertyCommentsMore',
    reserveOnlineUrl: 'https://palladionboutiquehotel.reserve-online.net/',
    liveVisitorsUrl:
        'https://ratestrip.abouthotelier.com/API/Price/LiveVisitors',
    developementUrl:
        'https://hotelmanager.abouthotelier.com/API/Price/GetPrice?url=https://palladion-hotel.gr/&lang=en-US',
    demoUrl:
        //    'https://devhotelmanager.abouthotelier.com/API/Price/GetPrice?url=http://hotelmanager.abouthotelier.com/newreservation/',
        // 'https://devhotelmanager.abouthotelier.com/API/Price/GetPrice?url=http://hotelmanager.abouthotelier.com/reactdemocart/',
        'https://devhotelmanager.abouthotelier.com/API/Price/GetPrice?url=http://hotelmanager.abouthotelier.com/',
    // 'https://devhotelmanager.abouthotelier.com/API/Price/GetPrice?url=http://hotelmanager.abouthotelier.com/test/',
    localUrl: 'http://localhost:3000/react/data/example-response.json',
    // developementUrl:
    //     'https://hotelmanager.abouthotelier.com/API/Price/GetPrice?url=https://palladion-hotel.gr/&lang=el-GR',
};

export const COOKIE_NAME = 'HotelManager_Plugin_';

export const WIDGET_STATS_SETTINGS = {
    actions: {
        open: 'open',
        click: 'click',
        offersClick: 'offers_click',
        search: 'search',
        booknow: 'booknow',
        phone: 'phone',
    },
    intervals: {
        openInterval: 10 * 60 * 1000, // 10 min,
        openMultipropertyInterval: 10 * 60 * 1000, // 10 min,
        clickInterval: 10 * 60 * 1000, // 10 min
    },
};

export const WIDGET_LOCAL_STORAGE_KEY = 'ab-mini-booking-widget';
